import curry from 'lodash.curry'

export const withInjectedProps = curry(
  (injectedProps: Record<string, any>, Component: (props: any) => JSX.Element | null) => {
    return function InjectedComponent(props: any) {
      return <Component {...injectedProps} {...props} />
    }
  }
)
